import{styled as i}from"@lokalise/styled";import{spacing as e}from"../../utils/theme/index.js";const o=i.div.withConfig({displayName:"Spacer__Container",componentId:"sc-sr3xs8-0"})(["padding:",";&:empty{display:none;}"],(({$padding:i})=>e(...i)));export{o as Container};
//# sourceMappingURL=styles.js.map
